import React, { Box, alpha, styled } from '@mui/material';
import { FC } from 'react';
import { TOC_ROUTES } from '../../screens/unauthenticated/toc/route.definitions';
import { BhabiLink } from './bhabi-link';

/** @deprecated kept for API compatibility — the footer now uses `.bh-footer`. */
export const FooterStyled = styled(Box, {
  shouldForwardProp: prop => prop !== 'isIOS',
})<{ isIOS: boolean }>(({ theme }) => ({
  color: alpha(theme.palette.text.primary, 0.6),
}));

export const Footer: FC = () => (
  <footer className="bh-footer">
    <span>Copyright &copy; {new Date().getFullYear()} Bhabi Inc.</span>
    <span aria-hidden="true">·</span>
    <BhabiLink to={TOC_ROUTES.ABSOLUTE_PATH} style={{ color: 'inherit' }}>
      Terms of service
    </BhabiLink>
  </footer>
);
